const paymentConfigTypes = {
  FETCH_PAYMENT_CONFIG_REQUEST: 'FETCH_PAYMENT_CONFIG_REQUEST',
  FETCH_PAYMENT_CONFIG_SUCCESS: 'FETCH_PAYMENT_CONFIG_SUCCESS',
  FETCH_PAYMENT_CONFIG_FAILURE: 'FETCH_PAYMENT_CONFIG_FAILURE',

  FETCH_PAYSTACK_CONFIG_REQUEST: 'FETCH_PAYSTACK_CONFIG_REQUEST',
  FETCH_PAYSTACK_CONFIG_SUCCESS: 'FETCH_PAYSTACK_CONFIG_SUCCESS',
  FETCH_PAYSTACK_CONFIG_FAILURE: 'FETCH_PAYSTACK_CONFIG_FAILURE',

  FETCH_REMITA_CONFIG_REQUEST: 'FETCH_REMITA_CONFIG_REQUEST',
  FETCH_REMITA_CONFIG_SUCCESS: 'FETCH_REMITA_CONFIG_SUCCESS',
  FETCH_REMITA_CONFIG_FAILURE: 'FETCH_REMITA_CONFIG_FAILURE',

  FETCH_INTERSWITCH_CONFIG_REQUEST: 'FETCH_INTERSWITCH_CONFIG_REQUEST',
  FETCH_INTERSWITCH_CONFIG_SUCCESS: 'FETCH_INTERSWITCH_CONFIG_SUCCESS',
  FETCH_INTERSWITCH_CONFIG_FAILURE: 'FETCH_INTERSWITCH_CONFIG_FAILURE',

  FETCH_NABROLL_CONFIG_REQUEST: 'FETCH_NABROLL_CONFIG_REQUEST',
  FETCH_NABROLL_CONFIG_SUCCESS: 'FETCH_NABROLL_CONFIG_SUCCESS',
  FETCH_NABROLL_CONFIG_FAILURE: 'FETCH_NABROLL_CONFIG_FAILURE',
  
  IMPORT_PAYMENT_CONFIG_REQUEST: 'IMPORT_PAYMENT_CONFIG_REQUEST',
  IMPORT_PAYMENT_CONFIG_SUCCESS: 'IMPORT_PAYMENT_CONFIG_SUCCESS',
  IMPORT_PAYMENT_CONFIG_FAILURE: 'IMPORT_PAYMENT_CONFIG_FAILURE',

  DELETE_PAYMENT_CONFIG_REQUEST: 'DELETE_PAYMENT_CONFIG_REQUEST',
  DELETE_REMITA_PAYMENT_CONFIG_SUCCESS: 'DELETE_REMITA_PAYMENT_CONFIG_SUCCESS',
  DELETE_PAYSTACK_PAYMENT_CONFIG_SUCCESS:
    'DELETE_PAYSTACK_PAYMENT_CONFIG_SUCCESS',
  DELETE_INTERSWITCH_PAYMENT_CONFIG_SUCCESS:
    'DELETE_INTERSWITCH_PAYMENT_CONFIG_SUCCESS',
  DELETE_PAYMENT_CONFIG_FAILURE: 'DELETE_PAYMENT_CONFIG_FAILURE',

  UPDATE_PAYMENT_CONFIG_REQUEST: 'UPDATE_PAYMENT_CONFIG_REQUEST',
  UPDATE_PAYMENT_CONFIG_SUCCESS: 'UPDATE_PAYMENT_CONFIG_SUCCESS',
  UPDATE_PAYMENT_CONFIG_FAILURE: 'UPDATE_PAYMENT_CONFIG_FAILURE',

  UPDATE_PLATFORM_CHARGE_REQUEST: 'UPDATE_PLATFORM_CHARGE_REQUEST',
};

export default paymentConfigTypes;
